/**
 * Mock 数据开关与工具函数。
 * 当 VITE_ENABLE_MOCK=true 时，API 服务使用本地 mock 数据而非真实 HTTP 请求。
 */
import { ENABLE_MOCK } from './client'

/** 判断是否使用 mock 模式 */
export function isMockEnabled(): boolean {
  return ENABLE_MOCK
}

/** 模拟网络延迟 (200-600ms) */
export function mockDelay(): Promise<void> {
  const ms = 200 + Math.random() * 400
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** 包装分页响应 */
export function paginate<T>(items: T[], page: number, pageSize: number) {
  const start = (page - 1) * pageSize
  const end = start + pageSize
  return {
    page,
    page_size: pageSize,
    total: items.length,
    items: items.slice(start, end),
  }
}

export function sortByParam<T>(
  items: T[],
  sortBy: string | undefined,
  sortOrder: string | undefined,
  aliases: Record<string, keyof T>,
) {
  const key = aliases[sortBy || 'created_at'] || aliases.created_at
  const direction = sortOrder === 'asc' ? 1 : -1
  return [...items].sort((a, b) => {
    const left = String(a[key] ?? '')
    const right = String(b[key] ?? '')
    return left.localeCompare(right) * direction
  })
}
